"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimValueWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var FalconQuestionWidgetBase_1 = require("../../FalconQuestionWidgetBase");
var InfoQuestionWrapper_1 = require("../../../components/infoQuestion/InfoQuestionWrapper");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var ClaimValueWidget = /** @class */ (function (_super) {
    __extends(ClaimValueWidget, _super);
    function ClaimValueWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidUpdate = function (prevProps, prevState) {
            var interactionClaimValueString = _this.bindFromField(_this.interactionField);
            if (prevState.claimValue !== interactionClaimValueString) {
                _this.setState({
                    claimValue: interactionClaimValueString
                });
            }
        };
        _this.handleOnChangeEvent = function (event) {
            var claimValue = event.target.value.replace(/[^0-9.]/g, '');
            _this.props.onStateChange(_this.props.question.interactionField, claimValue);
            _this.setState({ claimValue: claimValue });
            journey_services_1.ObjectManipulator.setField("uistate.claimChanged", _this.props.interaction, true);
            _this.changelogRecorder.recordQuestion("change", _this.props);
            _this.validateInternal(claimValue);
        };
        _this.interactionField = _this.props.question.interactionField;
        _this.state = {
            claimValue: ""
        };
        return _this;
    }
    ClaimValueWidget.prototype.componentDidMount = function () {
        var interactionClaimDate = this.bindFromField(this.interactionField);
        this.setState({
            claimValue: interactionClaimDate
        });
    };
    ClaimValueWidget.prototype.render = function () {
        var info = this.renderHtml(this.getSetting("infoHtml") || "");
        return ((0, jsx_runtime_1.jsxs)(InfoQuestionWrapper_1.InfoQuestionWrapper, { label: "Claim value", infoType: this.getSetting("infoType"), info: info, infoTitle: this.getSetting("infoTitle"), classNameOpened: this.getSetting("classNameOpened"), hideInfoButton: this.isMtaAndDisabled(), children: [this.renderInputField(), this.renderValidationResult()] }));
    };
    ClaimValueWidget.prototype.renderInputField = function () {
        var claimValue = "";
        if (this.state.claimValue !== "" && !isNaN(this.state.claimValue)) {
            claimValue = new Intl.NumberFormat('en-UK').format(this.state.claimValue);
        }
        return ((0, jsx_runtime_1.jsxs)("div", { className: "input-group d-flex align-items-center", children: [(0, jsx_runtime_1.jsx)("span", { className: "fs-22 font-weight-bold pr-2", children: "\u00A3" }), (0, jsx_runtime_1.jsx)("input", { type: "text", id: this.props.question.name, className: "form-control w-25 mx-2 rounded-0 ".concat(this.getInputValidationClass()), value: claimValue, onChange: this.handleOnChangeEvent, readOnly: this.isReadOnly() })] }));
    };
    ClaimValueWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "infoType", type: journey_model_1.TypeDescriptions.String },
            { name: "infoTitle", type: journey_model_1.TypeDescriptions.String },
            { name: "infoHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "classNameOpened", type: journey_model_1.TypeDescriptions.String },
            { name: "readOnlyExpression", type: journey_model_1.TypeDescriptions.Expression },
        ]),
        __metadata("design:paramtypes", [Object])
    ], ClaimValueWidget);
    return ClaimValueWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.ClaimValueWidget = ClaimValueWidget;
//# sourceMappingURL=ClaimValueWidget.js.map